import { api } from './api';
import { logger } from "../utils/logger";

export interface CompanyUser {
  id: number;
  email: string;
  full_name?: string;
  is_active: boolean;
  company_id: number;
  role?: 'admin' | 'user';
  is_company_admin?: boolean;
  created_at: string;
}

export interface CompanyUserCreate {
  email: string;
  password: string;
  full_name?: string;
  is_active?: boolean;
  company_id?: number;
  role?: 'admin' | 'user';
}

class UserService {
  async getCompanyUsers(): Promise<CompanyUser[]> {
    try {
      logger.log('Making API call to get company users...');
      const response = await api.get('/api/v1/company/me/users');
      return response.data;
    } catch (error) {
      logger.error('Error fetching company users:', error);
      throw error;
    }
  }

  async createCompanyUser(data: CompanyUserCreate): Promise<CompanyUser> {
    try {
      logger.log('Making API call to create company user:', data);
      const response = await api.post('/api/v1/company/me/users', data);
      return response.data;
    } catch (error) {
      logger.error('Error creating company user:', error);
      throw error;
    }
  }

  async updateCompanyUser(id: number, data: Partial<CompanyUserCreate>): Promise<CompanyUser> {
    try {
      const response = await api.put(`/api/v1/company/me/users/${id}`, data);
      return response.data;
    } catch (error) {
      logger.error('Error updating company user:', error);
      throw error;
    }
  }

  async deleteCompanyUser(id: number): Promise<void> {
    try {
      await api.delete(`/api/v1/company/me/users/${id}`);
    } catch (error) {
      logger.error('Error deleting company user:', error);
      throw error;
    }
  }
}

export const userService = new UserService(); 